module.exports = __webpack_public_path__ + "res/27-img_game_bg.74e67ab57f63762b8da0aae8fd005371.png";